import { toast } from "react-toastify";
import {
  fetchUpdatePOStart,
  fetchUpdatePOSuccess,
  fetchUpdatePOFailure,
} from "./reducer";
import { UPDATE_PO } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const updatePO =
  (jsonObj, orderId, itemId, setLoading, onSuccess, showToast = true) =>
  async (dispatch) => {
    dispatch(fetchUpdatePOStart());
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        UPDATE_PO(orderId, itemId),
        "PUT",
        jsonObj,
      );

      if (response?.error) {
        dispatch(fetchUpdatePOFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchUpdatePOSuccess(response));
        dispatch(setSuccessMessage(true));
        if (showToast) {
          toast.success(response.message);
        }
        if (onSuccess) {
          onSuccess();
        }
      }
    } catch (error) {
      dispatch(fetchUpdatePOFailure("Something went wrong"));
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };
